import { faSliders } from "@fortawesome/free-solid-svg-icons/faSliders";
export let iconSliders = faSliders;
export function overwriteSliders(icon) {
    iconSliders = icon;
}
export default iconSliders;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2xpZGVycy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9zbGlkZXJzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBLE9BQU8sRUFBRSxTQUFTLEVBQUUsTUFBTSw2Q0FBNkMsQ0FBQztBQUV4RSxNQUFNLENBQUMsSUFBSSxXQUFXLEdBQUcsU0FBUyxDQUFDO0FBRW5DLE1BQU0sVUFBVSxnQkFBZ0IsQ0FBQyxJQUFvQjtJQUNuRCxXQUFXLEdBQUcsSUFBSSxDQUFDO0FBQ3JCLENBQUM7QUFFRCxlQUFlLFdBQVcsQ0FBQyJ9